import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/icons
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Radio from '@material-ui/core/Radio';
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import AttachFile from '@material-ui/icons/AttachFile';

// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";

import customCheckboxRadioSwitch from "../../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import sweetAlertStyle from "../../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

const style = {
	checkBoxLabelError: {
		background: "#ff0000"
	},
	infoText: {
		fontWeight: "300",
		margin: "10px 0 30px",
		textAlign: "center"
	},
	inputAdornmentIcon: {
		color: "#555"
	},
	inputAdornment: {
		position: "relative"
	},
	...customCheckboxRadioSwitch,
	...sweetAlertStyle
};

class Step2 extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selected: "",
			selectedState: "",
			description: "",
			materialName:"",
			materialThickness:"",
			materialSize:"",
			materialGeometry:"",
			materialNeededPrecision:"",
			file:"",
			fileUrl:"",
			alert: null
		};
		this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
		this.handleFileUpload = this.handleFileUpload.bind(this);
		this.hideAlert = this.hideAlert.bind(this);
	}

	hideAlert() {
		this.setState({
			alert: null
		});
	}

	toBigAlert() {
		this.setState({
			alert: (
				<SweetAlert
					warning
					style={{ display: "block", marginTop: "-100px" }}
					title="Datei zu groß!"
					onConfirm={() => this.hideAlert()}
					onCancel={() => this.hideAlert()}
					confirmBtnCssClass={
						this.props.classes.button + " " + this.props.classes.success
					}
				>
					Bitte nur Dateien mit einer Größe bis zu 4MB hochladen.
				</SweetAlert>
			)
		});
	}

	renderDescription(){
		this.setState({
			description: [
				"Bezeichnung: ",
				this.state.materialName,
				"Stärke: ",
				this.state.materialThickness,
				"Substratgröße: ",
				this.state.materialSize,
				"Geometrie: ",
				this.state.materialGeometry,
				"Präzision: ",
				this.state.materialNeededPrecision,
				"Datei: ",
				this.state.file.name
			].join(' ')
		})
	}

	change(event, stateName, type = null){

		switch (type) {
			case "checkbox":
				if (event.target.checked) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
					this.setState({ [stateName + "State"]: "error" });
				}
				break;
			default:
				break;
		}

		this.setState({ [stateName]: event.target.value }, () => {
			this.renderDescription();
		});
	}

	handleChangeEnabled(event) {
		this.change(event, "selected")
	}

	handleFileUpload(e) {
		e.preventDefault();
		let reader = new FileReader();
		let file = e.target.files[0];

		if (file.size > 4096000){
			this.toBigAlert();
			e.target.value = null;
			return false;
		}

		reader.onloadend = () => {
			this.setState({
				file: file,
				fileUrl: reader.result
			}, () => {
				this.renderDescription();
			});
		}
		reader.readAsDataURL(file);
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		if (this.state.selectedState === "success"){
			return true;
		} else {
			this.setState({ selectedState: "error" });
		}
		return false;
	}

	isError(){
		return this.state.selectedState === "error"
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
			{this.state.alert}
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={12}>
					<h4 className={classes.infoText}>
						Bitte beschreiben Sie Ihr Material
					</h4>
				</GridItem>
			</GridContainer>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Glas"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Glas"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Glas"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Metall"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Metall"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Metall"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Halbleiter"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Halbleiter"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Halbleiter"
					/>
				</div>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Keramik"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Keramik"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Keramik"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Polymer"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Polymer"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Polymer"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Dünnschichten"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Dünnschichten"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Dünnschichten"
					/>
				</div>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={3}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Multilayer/Stack"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Multilayer/Stack"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Multilayer/Stack"
					/>
				</div>
				</GridItem>
				<GridItem xs={3}></GridItem>
				<GridItem xs={3}></GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={3}>
					<CustomInput
						labelText="Materialname"
						id="material-name"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "materialName")
						}}
					/>
				</GridItem>
				<GridItem xs={3}>
					<CustomInput
						labelText="Materialstärke"
						id="material-thickness"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "materialThickness")
						}}
					/>
				</GridItem>
				<GridItem xs={3}>
					<CustomInput
						labelText="Substratgröße/Bauteilgröße"
						id="material-size"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "materialSize")
						}}
					/>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={6}>
					<CustomInput
						labelText="Bearbeitungsgeometrie"
						id="material-geometry-desc"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "materialGeometry")
						}}
					/>
				</GridItem>
				<GridItem xs={3}>
					<CustomInput
						labelText="Erforderliche Genauigkeit"
						id="material-precisision"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "materialNeededPrecision")
						}}
					/>
				</GridItem>
			</GridContainer>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={9}>
					<FormControl className={classes.margin}>
						<InputLabel htmlFor="input-with-icon-adornment">Dokument hochladen</InputLabel>
						<Input
							id="input-with-icon-adornment"
							type="file"
							accept="image/*; application/*"
							startAdornment={
								<InputAdornment position="start">
									<AttachFile />
								</InputAdornment>
							}
							onChange={this.handleFileUpload}
							ref="fileInput"
						/>
					</FormControl>
				</GridItem>
			</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(Step2);



// WEBPACK FOOTER //
// ./src/views/Configurator/ConfiguratorSteps/Step2.jsx